import React from "react";
import Tooltip from "../Tooltip";

const NARROW_THRESHOLD = 340;

const SettingItem = ({
  title,
  titleSuffix,
  subtitle,
  tooltip,
  iconColor,
  rightContent,
  forceRow,
  alignTop,
  "data-tour-id": dataTourId,
}) => {
  const containerRef = React.useRef(null);
  const [isNarrow, setIsNarrow] = React.useState(false);

  React.useEffect(() => {
    if (forceRow) return;
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setIsNarrow(entry.contentRect.width < NARROW_THRESHOLD);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [forceRow]);

  return (
    <div
      ref={containerRef}
      data-tour-id={dataTourId}
      className={`flex px-[20px] py-2.5 ${isNarrow ? "flex-col items-start gap-2" : `flex-row justify-between ${alignTop ? "items-start" : "items-center"}`}`}
    >
      <div
        className={`flex gap-3 min-w-0 ${alignTop && !isNarrow ? "items-start" : "items-center"}`}
      >
        {iconColor && (
          <div
            className="w-3 h-3 rounded-full shrink-0"
            style={{ backgroundColor: iconColor }}
          />
        )}
        <div className="flex flex-col min-w-0">
          <span className="flex items-center gap-[6px] text-[14px] font-medium text-[#111827] leading-[20px]">
            {title}
            {tooltip && <Tooltip text={tooltip} />}
            {titleSuffix}
          </span>
          {subtitle && (
            <span className="text-[12px] text-[#636369] leading-[18px] whitespace-normal">
              {subtitle}
            </span>
          )}
        </div>
      </div>
      <div className={`shrink-0 ${!isNarrow ? "ml-4" : ""}`}>
        {rightContent}
      </div>
    </div>
  );
};

export default React.memo(SettingItem);
